<template>
  <v-container>
    <v-subheader class="text-subtitle-1 font-weight-bold grey--text text--darken-2">
      <v-icon color="blue darken-2">mdi-text-box-outline</v-icon>
      <span class="ml-2">{{$t('lang.conferenceCallForPapers')}}</span>
    </v-subheader>
    <div v-if="step === 1">
      <div class="mx-6 mx-sm-12 my-2 my-sm-6">
        <span class="font-weight-bold text-subtitle-1 black--text">{{$t('lang.themes')}}：</span>
        <span class="text-subtitle-1 grey--text text--darken-3" v-text="subject"></span>
      </div>
      <div class="mx-6 mx-sm-12 my-2 my-sm-6">
        <span class="font-weight-bold text-subtitle-1 black--text">{{$t('lang.deadline')}}：</span>
        <span class="text-subtitle-1 grey--text text--darken-3" v-text="solicitationTime.split('--')[1]"></span>
      </div>
      <div class="mx-6 mx-sm-12 my-2 my-sm-6">
        <span class="font-weight-bold text-subtitle-1 black--text">{{$t('lang.guidelines')}}：</span>
      </div>
      <div class="mx-6 mx-sm-12 my-2 my-sm-6">
        <span class="d-inline-block text-subtitle-1 grey--text text--darken-3 mx-auto" v-html="Notes"></span>
      </div>
      <div>
        <v-row no-gutters class="d-flex justify-space-around">
          <v-col cols="12" sm="2" class="my-2" v-if="data.IsOrgEssay !== 1">
            <v-btn block color="primary" style="text-transform:none;" @click="expire(data.SolicitationTime.split('--')[1].replace(/-/g, '/')) ? showDialog(0) : toStep2Or5(0)">{{data.IsOrgEssay === 2 ? $t('lang.submitPersonalPaper') : $t('lang.submitPaper')}}</v-btn>
          </v-col>
          <v-col cols="12" sm="2" class="my-2" v-if="data.IsOrgEssay !== 0">
            <v-btn block color="primary" style="text-transform:none;" @click="expire(data.SolicitationTime.split('--')[1].replace(/-/g, '/')) ? showDialog(0) : toStep2Or5(1)">{{data.IsOrgEssay === 2 ? $t('lang.submitorGanizationPaper') : $t('lang.submitPaper')}}</v-btn>
          </v-col>
          <!-- <v-col cols="12" sm="2" class="my-2">
            <v-btn block color="primary" style="text-transform:none;" @click="expire(data.SolicitationTime.split('--')[1].replace(/-/g, '/')) ? showDialog(0) : toStep2Or5(data.IsOrgEssay)">{{$t('lang.submitPaper')}}</v-btn>
          </v-col> -->
          <v-col cols="12" sm="2" class="my-2">
            <v-btn block style="text-transform:none;" color="primary" @click="review()">{{$t('lang.paperReview')}}</v-btn>
          </v-col>
          <v-col cols="12" sm="2" class="my-2">
            <!-- <v-btn block style="text-transform:none;" color="primary" @click="msg= $store.getters.getLanguage === 0 ? '暂未到评审时间，请稍后再查' : 'We haven\'t conducted the review yet. Please check later';dialog=true">{{$t('lang.queryAwardResults')}}</v-btn> -->
            <v-btn block style="text-transform:none;" color="primary" @click="$store.getters.getLogin2 ? step = 4 : login = true">{{$t('lang.queryAwardResults')}}</v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
    <div v-if="step == 5">
      <v-radio-group v-model="fee">
        <v-col cols="12">
          <v-radio v-if="feeData.EntryFee !== 0" :label="$t('lang.nonMembers') + feeData.EntryFee.toFixed(2) + $t('lang.rmb')" :value="1"></v-radio>
          <v-radio v-if="isOrgEssay !== 1 && feeData.PersonalFee !== 0" :label="$t('lang.individualMember') + (feeData.IsMemberSingup === 0 ? feeData.EntryFee.toFixed(2) : feeData.PersonalFee.toFixed(2)) + $t('lang.rmb')" :value="2"></v-radio>
          <v-radio v-if="isOrgEssay !== 0 && feeData.TeamFee !== 0" :label="$t('lang.organizationMember') + (feeData.IsMemberSingup === 0 ? feeData.EntryFee.toFixed(2) : feeData.TeamFee.toFixed(2)) + $t('lang.rmb')" :value="3"></v-radio>
        </v-col>
      </v-radio-group>
      <div class="my-6 d-flex justify-space-around justify-sm-center">
        <v-btn class="mx-sm-10" style="text-transform:none;" color="primary" @click="step = 1">{{$t('lang.back')}}</v-btn>
        <v-btn color="primary" style="text-transform:none;" @click="feeType()" :loading="loading">{{$t('lang.next')}}</v-btn>
      </div>
    </div>
    <v-form v-if="step == 6" ref="form6">
      <v-row no-gutters>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-2">
          <span class="my-auto red--text">*</span>
          <span class="my-auto">{{$t('lang.name')}}</span>
        </v-col>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
          <v-text-field v-model="step6Name" outlined clearable required dense :rules="nameRules"></v-text-field>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-2">
          <span class="my-auto red--text">*</span>
          <span class="my-auto">{{$t('lang.ids')}}</span>
        </v-col>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
          <v-text-field v-model="step6Ids" outlined clearable required dense :rules="nullRules"></v-text-field>
        </v-col>
      </v-row>
      <div class="my-6 d-flex justify-space-around justify-sm-center">
        <v-btn class="mx-sm-10" style="text-transform:none;" color="primary" @click="step = 5">{{$t('lang.back')}}</v-btn>
        <v-btn color="primary" style="text-transform:none;" @click="isExistsPersonalMember()" :loading="loading">{{$t('lang.next')}}</v-btn>
      </div>
    </v-form>
    <v-form v-if="step == 7" ref="form7">
      <!-- 单位名称 -->
      <v-row no-gutters>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-2">
          <span class="my-auto red--text">*</span>
          <span class="my-auto">{{$t('lang.companyName')}}</span>
        </v-col>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
          <v-text-field v-model="step7Name" outlined clearable required dense :rules="companyRules"></v-text-field>
        </v-col>
      </v-row>
      <!-- 组织机构代码 -->
      <v-row no-gutters>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-2">
          <span class="my-auto red--text">*</span>
          <span class="my-auto">{{$t('lang.organizationCode')}}</span>
        </v-col>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
          <v-text-field v-model="step7Ids" outlined clearable required dense :rules="nullRules"></v-text-field>
        </v-col>
      </v-row>
      <div class="my-6 d-flex justify-space-around justify-sm-center">
        <v-btn class="mx-sm-10" style="text-transform:none;" color="primary" @click="step = 5">{{$t('lang.back')}}</v-btn>
        <v-btn color="primary" style="text-transform:none;" @click="isExistsTeamMember()" :loading="loading">{{$t('lang.next')}}</v-btn>
      </div>
    </v-form>
    <v-form v-if="step === 2" ref="form1" class="mt-4 mx-6 mx-sm-12 my-2 my-sm-6">
      <!-- 提交人姓名 -->
      <v-row no-gutters>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-2">
          <span class="my-auto red--text">*</span>
          <span class="my-auto">{{$t('lang.name')}}</span>
        </v-col>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
          <v-text-field v-model="name" outlined clearable required dense :rules="nameRules"></v-text-field>
        </v-col>
      </v-row>
      <!-- 单位名称 -->
      <v-row no-gutters>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-2">
          <span class="my-auto red--text">*</span>
          <span class="my-auto">{{$t('lang.companyName')}}</span>
        </v-col>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
          <v-text-field v-model="companyName" outlined clearable required dense :rules="companyRules"></v-text-field>
        </v-col>
      </v-row>
      <!-- 身份证号码 -->
      <v-row no-gutters>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-2">
          <span class="my-auto red--text">*</span>
          <span class="my-auto">{{$t('lang.ids')}}</span>
        </v-col>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
          <v-text-field v-model="ids" outlined clearable required dense :rules="nullRules"></v-text-field>
        </v-col>
      </v-row>
      <!-- 电话/邮箱 -->
      <v-row no-gutters>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-2">
          <span class="my-auto red--text">*</span>
          <span class="my-auto">{{$t('lang.phoneOrEmail')}}</span>
        </v-col>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
          <v-text-field v-model="phoneOrEmail" outlined clearable required dense :rules="phoneOrEmailRules"></v-text-field>
        </v-col>
      </v-row>
      <!-- 区域选择 -->
      <div>
        <v-row dense>
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
            <span class="my-auto red--text">*</span>
            <span class="my-auto">{{$t('lang.location')}}</span>
          </v-col>
          <v-col cols="12" sm="10">
            <v-radio-group v-model="areaSwitch" row mandatory class="ma-0 pa-0">
              <v-radio :label="$t('lang.china')" :value="true"></v-radio>
              <v-radio :label="$t('lang.otherCountry')" :value="false"></v-radio>
            </v-radio-group>
            <v-text-field v-if="!areaSwitch" :placeholder="$t('lang.otherCountryName')" v-model="otherCountry" outlined clearable required dense></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="areaSwitch">
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="ma-0 pa-0">
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-select placeholder="选择省份" v-model="selectProvince" outlined dense :items="province" item-text="ProName" item-value="ProID" required @change="provinceEvent()"></v-select>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-select placeholder="选择城市" no-data-text="" v-model="selectCity" outlined dense :items="city" item-text="CityName" item-value="CityID" required @change="cityEvent()"></v-select>
          </v-col>
          <v-col class="d-flex" cols="12" sm="2">
            <v-select placeholder="选择区" no-data-text="" v-model="selectDistrict" outlined dense :items="district" item-text="DisName" item-value="Id" required @change="districtEvent()"></v-select>
          </v-col>
          <!-- <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 5 : 4">
            <v-text-field placeholder="详细地址" v-model="detail" outlined clearable required dense></v-text-field>
          </v-col> -->
        </v-row>
      </div>
      <div class="d-flex justify-space-around justify-sm-center">
        <v-btn class="mx-sm-10" style="text-transform:none;" color="primary" @click="feeData.IsOnlinePay === 1 ? step = 5 : step = 1">{{$t('lang.back')}}</v-btn>
        <v-btn color="primary" style="text-transform:none;" @click="next()" :loading="loading">{{$t('lang.next')}}</v-btn>
      </div>
    </v-form>
    <v-form v-show="step === 3" ref="form2" class="mt-4 mx-6 mx-sm-12 my-2 my-sm-6">
      <!-- 征文标题 -->
      <v-row no-gutters>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-2">
          <span class="my-auto red--text">*</span>
          <span class="my-auto">{{$t('lang.documentTitle')}}</span>
        </v-col>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
          <v-text-field v-model="documentTitle" outlined clearable required dense :rules="documentTitleRules"></v-text-field>
        </v-col>
      </v-row>
      <!-- 作者姓名 -->
      <v-row no-gutters>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-2">
          <span class="my-auto red--text">*</span>
          <span class="my-auto">{{$t('lang.authorName')}}</span>
        </v-col>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
          <v-text-field v-model="authorName" outlined clearable required dense :rules="authorNameRules"></v-text-field>
        </v-col>
      </v-row>
      <!-- 内容分类 -->
      <v-row dense>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-0 pt-0">
          <span class="my-auto red--text">*</span>
          <span class="my-auto">{{$t('lang.classification')}}</span>
        </v-col>
        <v-col cols="12" sm="10" class="mt-0 pt-0">
          <v-radio-group v-model="contentRadio" class="mt-0 pt-0">
            <v-radio v-for="(item, n) in contents" :key="n" :label="$store.getters.getLanguage === 0 ? item.TypeName : item.TypeEnglishName" :value="item.DocumentTypeid"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <!-- 上传征文 -->
      <v-row dense>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
          <span class="my-auto red--text">*</span>
          <span class="my-auto">{{$t('lang.uploadDocument')}}</span>
        </v-col>
        <v-col v-if="!isMobile()" cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
          <v-file-input @click="fileOnClick" @change="fileOnChange" @click:clear="fileOnClear" v-model="files" multiple outlined dense prepend-icon="" prepend-inner-icon="mdi-file" :placeholder="$t('lang.uploadDocument')" accept="image/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf, .txt">
            <template v-slot:selection="{ index }">
              <!-- <v-chip v-if="index < 0" small label color="primary" close @click:close="files.splice(index, 1)">{{ text }}</v-chip> -->
              <span v-if="index === 0" class="articles-upload-text">{{ $t('lang.uploadDocument') }}</span>
            </template>
          </v-file-input>
        </v-col>
        <v-col v-if="isMobile()" cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
          <van-uploader :after-read="onRead" multiple v-model="files" :preview-image="false" accept="image/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf, .txt">
            <v-text-field outlined clearable required dense readonly :placeholder="$t('lang.uploadDocument')"></v-text-field>
          </van-uploader>
        </v-col>
        <v-col cols="12" :offset-sm="$store.getters.getLanguage === 0 ? 1 : 2" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
          <div v-for="(item, index) in files" :key="index">
            <v-chip class="mb-2" small label color="primary" close @click:close="files.splice(index, 1)">{{ isMobile() ? item.file.name : item.name}}</v-chip>
          </div>
        </v-col>
        <v-col cols="12" :offset-sm="$store.getters.getLanguage === 0 ? 1 : 2" sm="10">{{$t('lang.uploadDocumentTips')}}</v-col>
        <v-col cols="12" :offset-sm="$store.getters.getLanguage === 0 ? 1 : 2" sm="10" v-if="files"></v-col>
        <!-- <v-col cols="12" :offset-sm="$store.getters.getLanguage === 0 ? 1 : 2" sm="10" class="red--text">{{$t('lang.uploadDocumentTips2')}}</v-col> -->
      </v-row>
      <!-- 上传视频 -->
      <v-row v-show="feeData.IsAllowUploadVideo === 1" dense>
        <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
          <!-- <span class="my-auto red--text">*</span> -->
          <span class="my-auto">{{$t('lang.uploadVideo')}}</span>
        </v-col>
        <v-col cols="12" sm="10" v-show="!vedioFile">
          <v-btn outlined id="pickfiles" @click="refreshUploader()">{{ $t('lang.uploadVideo') }}</v-btn>
        </v-col>
        <v-col class="d-flex" cols="12" sm="10" v-if="isUploaded">
          <div v-show="isUploaded" style="position:relative;width:250px;height:148px">
            <video style="object-fit:cover;" id="myVideo" width="100%" height="100%" @durationchange="canPlay = true" @canplay="canPlay = true" controls controlsList="nodownload" :src="vedioUrl" >
            </video>
            <v-btn color="primary" style="position: absolute;top: 50%;left: 50%;transform: translateX(-50%) translateY(-50%);" v-show="isUploaded && !canPlay" @click="getVedioUrl()">{{ uploadPlayName }}</v-btn>
          </div>
          <div v-if="isUploaded && !canPlay" class="d-flex align-center primary--text ml-4">提示：视频正在转码中，稍等可预览</div>
        </v-col>
        <v-col cols="12" sm="5" v-if="vedioFile !== null && !isUploaded">
          <v-progress-linear class="my-2" :value="videoProgress" height="25"><strong style="color: white">{{ videoProgress }}%</strong></v-progress-linear>
        </v-col>
        <v-col cols="12" :offset-sm="$store.getters.getLanguage === 0 ? 1 : 2" sm="10" v-if="vedioFile">
          <v-chip class="mb-2" small label color="primary" close @click:close="uploader.removeFile(vedioFile)">{{ vedioFile.name | ellipsis}}</v-chip>
        </v-col>
        <v-col cols="12" :offset-sm="$store.getters.getLanguage === 0 ? 1 : 2" sm="10"><p v-html="$t('lang.uploadVideoTips')"></p></v-col>
        <v-col cols="12" :offset-sm="$store.getters.getLanguage === 0 ? 1 : 2" sm="10" v-if="vedioFile"></v-col>
        <!-- <v-col cols="12" :offset-sm="$store.getters.getLanguage === 0 ? 1 : 2" sm="10" class="red--text">{{$t('lang.uploadDocumentTips2')}}</v-col> -->
      </v-row>
      <div class="d-flex justify-space-around justify-sm-center">
        <v-btn class="mx-sm-10" style="text-transform:none;" color="primary" @click="reSubmit ? step = 4 : backStep2Or6Or7()">{{$t('lang.back')}}</v-btn>
        <v-btn color="primary" style="text-transform:none;" @click="submit()" :loading="loading">{{$t('lang.submit')}}</v-btn>
      </div>
    </v-form>
    <div v-if="step === 4">
      <v-simple-table>
        <template v-slot:default>
          <tbody>
            <tr>
              <td style="width:30%" class="black--text text--darken-2 text-subtitle-1">{{$t('lang.documentTitle')}}</td>
              <td class="grey--text text--darken-2 text-subtitle-1">{{ login2Data.Title }}</td>
            </tr>
            <tr>
              <td class="black--text text--darken-2 text-subtitle-1">{{$t('lang.classification')}}</td>
              <td class="grey--text text--darken-2 text-subtitle-1">{{ $store.getters.getLanguage === 0 ? login2Data.DocTypeName : login2Data.DocTypeEngName }}</td>
            </tr>
            <tr>
              <td class="black--text text--darken-2 text-subtitle-1">{{$t('lang.authorName')}}</td>
              <td class="grey--text text--darken-2 text-subtitle-1">{{ login2Data.CreateTrueName }}</td>
            </tr>
            <tr>
              <td class="black--text text--darken-2 text-subtitle-1">{{$t('lang.submitTime')}}</td>
              <td class="grey--text text--darken-2 text-subtitle-1">{{ createTime }}</td>
            </tr>
            <tr>
              <td class="black--text text--darken-2 text-subtitle-1">{{$t('lang.attachFile')}}</td>
              <td class="grey--text text--darken-2 text-subtitle-1">
                <div v-for="(file, i) in login2Data.FileList" :key="i">
                  {{ file.FileName | ellipsis}}
                  <v-chip small v-if="file.FileType === 2" class="ma-2" color="primary" @click="openFilePreview(file)">{{$t('lang.preview')}}</v-chip>
                  <v-chip small v-if="file.FileType !== 2" class="ma-2" color="primary" target="_blank" :href="file.FileUrl">{{$t('lang.preview')}}</v-chip>
                </div>
              </td>
            </tr>
            <tr>
              <td class="black--text text--darken-2 text-subtitle-1">{{$t('lang.status2')}}</td>
              <td class="grey--text text--darken-2 text-subtitle-1">{{ state }}</td>
            </tr>
            <tr v-if="login2Data.Status === 2">
              <td class="black--text text--darken-2 text-subtitle-1"></td>
              <td class="grey--text text--darken-2 text-subtitle-1">
                <van-image fit="cover" lazy-load height="240" width="240" :src="login2Data.AwardImg">
                  <!-- <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template> -->
                </van-image>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-row no-gutters class="d-flex justify-space-around">
        <v-col cols="12" sm="2" class="my-2">
          <v-btn block style="text-transform:none;" color="primary" @click="step = 1">{{$t('lang.back')}}</v-btn>
        </v-col>
          <v-col cols="12" sm="2" class="my-2" v-if="login2Data.Status === 0">
          <v-btn block color="primary" style="text-transform:none;" @click="reSubmit = true;step = 3">{{$t('lang.reSubmit')}}</v-btn>
        </v-col>
        <v-col cols="12" sm="2" class="my-2" v-if="login2Data.Status === 2">
          <v-btn block color="primary" style="text-transform:none;" @click="downloadIamge(login2Data.AwardImg)">{{$t('lang.downloadCertificate')}}</v-btn>
        </v-col>
      </v-row>
    </div>
    <v-snackbar v-model="snackbar" timeout="2000" centered color="primary" multi-line>
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          {{$t('lang.close')}}
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="dialog" persistent max-width="290" transition="dialog-top-transition">
      <v-card>
        <v-card-title class="headline">{{$t('lang.tips')}}</v-card-title>
        <v-card-text v-text="msg" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary"  @click="dialog = false">
            {{$t('lang.confirm')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Login2 v-if="login" :id="data.SolicitUrl.split('aid=')[1].split('&')[0]" @fatherEvent="login=false;if ($store.getters.getLogin2) step = 4"></Login2>
  </v-container>
</template>

<style>
  .articles-upload-text {
    color: rgba(0, 0, 0, 0.6);
  }
  .van-uploader, .van-uploader__input-wrapper {
    width: 100%;
  }
</style>

<script>
import Login2 from '@/components/Login2'
import urls from '../utils/urls'
import utils from '../utils/utils'
import CityJson from '../utils/CityJson'
import DistrictJson from '../utils/DistrictJson'
import ProJson from '../utils/ProJson'
import plupload from 'plupload'
export default {
  name: 'Articles',
  props: ['data', 'back'],
  filters: {
    ellipsis (value) {
      const len = value.length
      if (!value) return ''
      if (value.length > 30) {
        return value.substring(0, 10) + '......' + value.substring(len - 10, len)
      }
      return value
    }
  },
  watch: {
    back (val) {
      if (this.step !== 1) {
        this.step = 1
      }
    }
  },
  components: {
    Login2
  },
  computed: {
    subject () {
      return this.$store.getters.getLanguage === 0 ? this.data.SolicitSubject : this.data.SolicitEnglishSubject
    },
    Notes () {
      return this.$store.getters.getLanguage === 0 ? this.data.SolicitNotes : this.data.SolicitEnglishNotes
    },
    solicitationTime () {
      if (this.$store.getters.getLanguage === 0) {
        return this.data.SolicitationTime
      }
      return utils.methods.getEnglishDate2(this.data.SolicitationTime)
    },
    login2Data () {
      return this.$store.getters.getLogin2Data
    },
    createTime () {
      if (this.$store.getters.getLanguage === 0) {
        return this.$store.getters.getLogin2Data.CreateTime
      }
      return utils.methods.getEnglishDate(this.$store.getters.getLogin2Data.CreateTime)
    },
    state () {
      let state = ''
      switch (this.$store.getters.getLogin2Data.Status) {
        case 0:
          state = this.$store.getters.getLanguage === 0 ? '待审' : 'Waiting for review'
          break
        case 1:
          state = this.$store.getters.getLanguage === 0 ? '审核中' : 'Under review'
          break
        case 2:
          state = this.$store.getters.getLanguage === 0 ? '已获奖' : 'Win a prize'
          break
        case 3:
          state = this.$store.getters.getLanguage === 0 ? '未获奖' : 'No prize'
          break
        default:
          break
      }
      return state
    }
  },
  data: () => ({
    login: false,
    pingshen: urls.zhengwenpingshen,
    loading: false,
    dialog: false,
    snackbar: false,
    msg: '',
    step: 1,
    fee: null,
    feeData: {},
    name: '',
    step6Name: '',
    step6Ids: '',
    step7Name: '',
    step7Ids: '',
    companyName: null,
    ids: '',
    phoneOrEmail: null,
    areaSwitch: true,
    province: ProJson,
    city: [],
    district: [],
    selectProvince: null,
    selectCity: null,
    selectDistrict: null,
    detail: null,
    nameRules: [],
    companyRules: [],
    phoneOrEmailRules: [],
    nullRules: [],
    documentTitle: null,
    authorName: null,
    contentRadio: null,
    documentTitleRules: [],
    authorNameRules: [],
    files: [],
    vedioFile: null,
    files2: [],
    otherCountry: null,
    contents: null,
    isOrgEssay: null,
    obj: {},
    reSubmit: false,
    signature: {},
    hasFile: false,
    videoProgress: 0,
    g_object_name: '',
    suffix: '',
    uploader: null,
    isUploaded: false,
    maxtime: 60 * 5,
    timer: null,
    uploadPlayName: '',
    urlPrefix: '',
    vedioUrl: '',
    canPlay: false,
    timeInterval: null,
    videoInterval: null,
    transcodeFileName: '',
    transcodeUrl: ''
  }),
  mounted () {
    this.initRoles()
    this.getContent()
    this.uploadVedio()
  },
  methods: {
    initRoles () {
      if (this.isOrgEssay === 0) {
        this.nameRules = [
          v => !!v || this.$t('lang.nameCannotBeEmpty')
        ]
        this.nullRules = [
          v => !!v || this.$t('lang.idsCannotBeEmpty')
        ]
      }
      this.companyRules = [
        v => !!v || this.$t('lang.companyCannotBeEmpty')
      ]
      this.phoneOrEmailRules = [
        v => !!v || this.$t('lang.phoneOrEmailCannotBeEmpty'),
        v => (v && ((v && v.length === 11 && /^1[3456789]\d{9}$/.test(v)) || /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd0-9]+[-.])+[A-Za-zd]{2,5}$/.test(v))) || this.$t('lang.correctPhoneOrEmail')
      ]
    },
    initRoles2 () {
      this.documentTitleRules = [
        v => !!v || this.$t('lang.documentTitleCannotBeEmpty')
      ]
      this.authorNameRules = [
        v => !!v || this.$t('lang.authorNameCannotBeEmpty')
      ]
      this.phoneOrEmailRules = [
        v => !!v || this.$t('lang.phoneOrEmailCannotBeEmpty'),
        v => (v && ((v && v.length === 11 && /^1[3456789]\d{9}$/.test(v)) || /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd0-9]+[-.])+[A-Za-zd]{2,5}$/.test(v))) || this.$t('lang.correctPhoneOrEmail')
      ]
    },
    toStep2Or5 (isOrgEssay) {
      this.isOrgEssay = isOrgEssay
      console.log('---' + this.isOrgEssay)
      if (this.feeData && this.feeData.IsOnlinePay === 1) {
        this.step = 5
      } else {
        this.step = 2
      }
    },
    backStep2Or6Or7 () {
      if (this.feeData && this.feeData.IsOnlinePay === 1) {
        if (this.isOrgEssay === 0) {
          this.step = 6
        } else {
          this.step = 7
        }
      } else {
        this.step = 2
      }
    },
    showDialog (type) { // 0是报名截止，1是还没开始评审, 2是评审已结束
      switch (type) {
        case 0:
          this.msg = this.$store.getters.getLanguage === 0 ? '当前征文提交时间已截止。' : 'The time of subminting the Paper has ended.'
          break
        case 1:
          this.msg = this.$store.getters.getLanguage === 0 ? '当前征文正在提交中，暂不能进行评审。' : 'The paper is being submitted and cannot be reviewed at present.'
          break
        case 2:
          this.msg = this.$store.getters.getLanguage === 0 ? '评审已结束。' : 'The time of Paper review has ended.'
          break
        default:
          break
      }
      this.dialog = true
    },
    feeType () {
      console.log(this.fee)
      switch (this.fee) {
        case 1:
          this.step = 2
          break
        case 2:
          this.step = 6
          break
        case 3:
          this.step = 7
          break
        default:
          break
      }
    },
    generateEssayOrder () {
      this.loading = true
      this.$http({
        method: 'post',
        requestBase: 'VUE_APP_API_THREE',
        url: '/Api/Orders/GenerateEssayOrder',
        params: {
          aid: this.obj.Aid,
          kidStr: this.obj.Kid,
          userid: this.obj.Uid,
          doctypeid: this.obj.DocTypeId
        }
      }).then(res => {
        console.log(res)
        if (res.data.Status === 200) {
          this.pay(res.data)
        } else if (res.data.Status === 201 || res.data.Status === 202) {
          this.reSubmit = false
          this.step = 3
          this.loading = false
        } else {
          this.loading = false
          this.msg = res.data.Message
          this.dialog = true
          if (res.data.ret === 10) {
            this.step = 1
          }
        }
      }).catch(e => {
        this.loading = false
        console.log(e)
      })
    },
    isExistsPersonalMember () {
      this.nameRules = [
        v => !!v || this.$t('lang.nameCannotBeEmpty')
      ]
      this.nullRules = [
        v => !!v || this.$t('lang.idsCannotBeEmpty')
      ]
      if (this.$refs.form6.validate()) {
        this.loading = true
        this.$http({
          method: 'post',
          requestBase: 'VUE_APP_API_THREE',
          url: '/Account/IsExistsPersonalMember',
          params: {
            aid: this.data.SolicitUrl.split('aid=')[1].split('&')[0],
            kidStr: this.feeData.Kid,
            name: this.step6Name,
            card: this.step6Ids
          }
        }).then(res => {
          console.log(res.data)
          if (res.data.Status === 200) {
            this.obj.Uid = res.data.UserIdStr
            this.obj.Kid = this.feeData.Kid
            this.obj.Aid = this.data.SolicitUrl.split('aid=')[1].split('&')[0]
            this.pay(res.data)
          } else if (res.data.Status === 201 || res.data.Status === 202) {
            this.obj.Uid = res.data.UserIdStr
            this.obj.Kid = this.feeData.Kid
            this.obj.Aid = this.data.SolicitUrl.split('aid=')[1].split('&')[0]
            this.obj.IsAddEssay = res.data.IsAddEssay
            if (res.data.IsAddEssay) {
              this.obj.Abid = res.data.Abid
              this.reSubmit = true
            } else {
              this.reSubmit = false
            }
            this.step = 3
            this.loading = false
          } else {
            this.loading = false
            this.msg = res.data.Message
            this.dialog = true
            if (res.data.ret === 10) {
              this.step = 1
            }
          }
        }).catch(e => {
          this.loading = false
          console.log(e)
        })
      }
    },
    isExistsTeamMember () {
      this.companyRules = [
        v => !!v || this.$t('lang.companyCannotBeEmpty')
      ]
      this.nullRules = [
        v => !!v || this.$t('lang.idsCannotBeEmpty')
      ]
      if (this.$refs.form7.validate()) {
        this.loading = true
        this.$http({
          method: 'post',
          requestBase: 'VUE_APP_API_THREE',
          url: '/Account/IsExistsTeamMember',
          params: {
            aid: this.data.SolicitUrl.split('aid=')[1].split('&')[0],
            kidStr: this.feeData.Kid,
            name: this.step7Name,
            card: this.step7Ids
          }
        }).then(res => {
          console.log(res.data)
          if (res.data.Status === 200) {
            this.obj.Uid = res.data.UserIdStr
            this.obj.Kid = this.feeData.Kid
            this.obj.Aid = this.data.SolicitUrl.split('aid=')[1].split('&')[0]
            this.pay(res.data)
          } else if (res.data.Status === 201 || res.data.Status === 202) {
            this.obj.Uid = res.data.UserIdStr
            this.obj.Kid = this.feeData.Kid
            this.obj.Aid = this.data.SolicitUrl.split('aid=')[1].split('&')[0]
            this.obj.IsAddEssay = res.data.IsAddEssay
            if (res.data.IsAddEssay) {
              this.obj.Abid = res.data.Abid
              this.reSubmit = true
            } else {
              this.reSubmit = false
            }
            this.step = 3
            this.loading = false
          } else {
            this.loading = false
            this.msg = res.data.Message
            this.dialog = true
            if (res.data.ret === 10) {
              this.step = 1
            }
          }
        }).catch(e => {
          this.loading = false
          console.log(e)
        })
      }
    },
    pay (data) {
      const h5Url = data.H5PayUrl + '&backurl=' + this.getInvoicingLink() + '&backname=' + this.getInvoicingName()
      const webUrl = data.WebPayUrl + '&backurl=' + this.getInvoicingLink()
      const payUrl = utils.methods.isMobile() ? h5Url : webUrl
      console.log(payUrl)
      if (this.$store.getters.getLanguage === 0) {
        if (utils.methods.isMobile() && !utils.methods.isWeiXin()) {
          this.msg = '请在电脑端打开链接，点击“会议缴费”完成缴费操作。'
          this.snackbar = true
        } else {
          window.location.href = payUrl
        }
      }
    },
    getInvoicingLink () {
      let url = ''
      if (this.$store.getters.getData.InvoicingLink) {
        url = this.$store.getters.getData.InvoicingLink.indexOf('http://') === -1 && this.$store.getters.getData.InvoicingLink.indexOf('https://') === -1 ? 'http://' + this.$store.getters.getData.InvoicingLink : this.$store.getters.getData.InvoicingLink
      } else {
        url = window.location.href + '&userid=' + this.obj.Uid + '&kid=' + this.obj.Kid + '&doctypeid=' + this.obj.DocTypeId + '&aid=' + this.obj.Aid + '&isOrgEssay=' + this.isOrgEssay
      }
      return encodeURIComponent(url)
    },
    getInvoicingName () {
      if (this.$store.getters.getData.InvoicingLink) {
        return encodeURIComponent('预约开票')
      } else {
        return encodeURIComponent('返回')
      }
    },
    provinceEvent () {
      const city = []
      for (let b = 0; b < CityJson.length; b++) {
        const element = CityJson[b]
        if (element.ProID === this.selectProvince) {
          city.push(element)
        }
      }
      this.city = city
    },
    cityEvent () {
      const district = []
      for (let b = 0; b < DistrictJson.length; b++) {
        const element = DistrictJson[b]
        if (element.CityID === this.selectCity) {
          district.push(element)
        }
      }
      this.district = district
    },
    districtEvent (val) {
    },
    next () {
      this.initRoles()
      if (this.$refs.form1.validate()) {
        if (this.areaSwitch && !(this.selectProvince && this.selectCity && this.selectDistrict)) {
          this.msg = this.$store.getters.getLanguage === 0 ? '请选择所在区域' : 'Please select your location'
          this.snackbar = true
          return
        }
        if (!this.areaSwitch && !this.otherCountry) {
          this.msg = this.$store.getters.getLanguage === 0 ? '请填写所在区域' : 'Please fill in your location'
          this.snackbar = true
          return
        }
        this.loading = true
        this.$http({
          method: 'post',
          requestBase: 'VUE_APP_API_TWO',
          url: '/ComActivity/PreEnrolleAdd',
          data: {
            Aid: this.data.SolicitUrl.split('aid=')[1].split('&')[0],
            MemberName: this.name,
            Company: this.companyName,
            IdCard: this.ids,
            Phone: this.phoneOrEmail,
            ProvinceId: this.areaSwitch ? this.selectProvince : 0,
            CityId: this.areaSwitch ? this.selectCity : 0,
            DistrictId: this.areaSwitch ? this.selectDistrict : 0,
            OtherArea: !this.areaSwitch ? this.otherCountry : 0,
            IsOrgEssay: this.isOrgEssay
          }
        }).then(res => {
          console.log(res)
          if (res.data.ret === 0) {
            this.obj = res.data
            if (this.feeData.IsOnlinePay === 1) {
              this.generateEssayOrder()
            } else {
              this.reSubmit = false
              this.step = 3
              this.loading = false
            }
          } else {
            this.loading = false
            // this.msg = res.data.msg
            // this.snackbar = true
            this.msg = this.$store.getters.getLanguage === 0 ? res.data.msg : res.data.EngMsg
            this.dialog = true
            if (res.data.ret === 10) {
              this.step = 1
            }
          }
        }).catch(e => {
          this.loading = false
          console.log(e)
        })
      }
    },
    getContent () {
      this.$http.get('/ComActivity/GetActivityTypeList', {
        requestBase: 'VUE_APP_API_TWO',
        params: {
          id: this.data.SolicitUrl.split('aid=')[1].split('&')[0]
        }
      }).then(res => {
        if (res.data.ret === 0) {
          console.log(res.data)
          this.contents = res.data.DocumentTypeList
          this.feeData = res.data
          if (utils.methods.getRequest('userid') && utils.methods.getRequest('kid')) {
            this.step = 3
            this.obj.Uid = utils.methods.getRequest('userid')
            this.obj.Kid = utils.methods.getRequest('kid')
            this.obj.Aid = utils.methods.getRequest('aid')
            this.obj.DocTypeId = utils.methods.getRequest('doctypeid')
            this.isOrgEssay = utils.methods.getRequest('isOrgEssay')
          }
        } else {
          this.msg = res.data.msg
          this.snackbar = true
        }
      }).catch(e => {
        this.msg = 'error'
        this.snackbar = true
        console.log(e)
      })
    },
    submit () {
      this.initRoles2()
      if (this.$refs.form2.validate()) {
        if (!this.documentTitle) {
          this.msg = this.$store.getters.getLanguage === 0 ? '请填写征文标题' : 'Please input the title'
          this.snackbar = true
          return
        }
        if (!this.authorName) {
          this.msg = this.$store.getters.getLanguage === 0 ? '请填写作者姓名' : 'Please input the Author(s)'
          this.snackbar = true
          return
        }
        if (!this.contentRadio) {
          this.msg = this.$store.getters.getLanguage === 0 ? '请选择内容分类' : 'Please select Sub-themes'
          this.snackbar = true
          return
        }
        if (!this.files || this.files.length === 0) {
          this.msg = this.$t('lang.uploadDocumentTips2')
          this.snackbar = true
          return
        }
        console.log(this.isOrgEssay)
        const formData = new FormData()
        if (!this.reSubmit) {
          console.log(this.obj)
          formData.append('Uid', this.obj.Uid)
          formData.append('Kid', this.obj.Kid)
          formData.append('IsOrgEssay', this.isOrgEssay)
        } else {
          formData.append('IsOrgEssay', '0')
        }
        formData.append('Aid', this.data.SolicitUrl.split('aid=')[1].split('&')[0])
        formData.append('DocTypeId', this.contentRadio)
        formData.append('Title', this.documentTitle)
        formData.append('AuthorName', this.authorName ? this.authorName : '')
        if (this.reSubmit) {
          formData.append('AbId', this.obj.Abid || this.login2Data.AbId)
        }
        if (this.vedioFile) {
          console.log('/' + this.g_object_name)
          formData.append('VideoName', this.transcodeFileName)
          formData.append('VideoFileSize', this.vedioFile.size)
          formData.append('VideoUrl', '/' + this.transcodeUrl)
        }
        for (let index = 0; index < this.files.length; index++) {
          // this.msg = this.files[index].file.name
          // this.dialog = true
          // break
          if (this.isMobile()) {
            // this.files[index].file.name = decodeURIComponent(this.files[index].file.name)
            // this.msg = this.files[index].file.name
            // this.dialog = true
            formData.append('', this.files[index].file)
          } else {
            formData.append('', this.files[index])
          }
        }
        console.log(formData)
        this.loading = true
        this.$http({
          method: 'post',
          requestBase: 'VUE_APP_API_TWO',
          url: '/ComActivity/PreEnrolleSecondAdd',
          data: formData
        }).then(res => {
          console.log(res)
          if (res.data.ret === 0) {
            this.msg = this.$store.getters.getLanguage === 0 ? res.data.SuccessTips : res.data.SuccessTipsEnglish
            this.dialog = true
            this.$store.commit('setLogin2', false)
            this.step = 1
            this.loading = false
          } else {
            this.msg = res.data.msg
            this.snackbar = true
            this.loading = false
          }
        }).catch(e => {
          this.loading = false
          console.log(e)
        })
      }
    },
    getUrlBase64 (url) {
      return new Promise(resolve => {
        let canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        const img = new Image()
        img.crossOrigin = 'Anonymous' // 允许跨域
        img.src = url
        img.onload = () => {
          canvas.height = img.height
          canvas.width = img.width
          ctx.drawImage(img, 0, 0, img.width, img.height)
          const dataURL = canvas.toDataURL('image/' + url.substring(url.lastIndexOf('.') + 1, url.length))
          canvas = null
          resolve(dataURL)
        }
      })
    },
    downloadIamge (imgsrc) { // 下载图片地址和图片名
      this.getUrlBase64(imgsrc).then(base64 => {
        const link = document.createElement('a')
        link.href = base64
        const name = this.$store.getters.getLanguage === 0 ? '证书' : 'award'
        link.download = name + '.' + imgsrc.substring(imgsrc.lastIndexOf('.') + 1, imgsrc.length)
        link.click()
      })

      // const xmlhttp = new XMLHttpRequest()
      // xmlhttp.open('GET', imgsrc, true)
      // xmlhttp.responseType = 'blob'
      // xmlhttp.onload = () => {
      //   if (this.status === 200) {
      //     const blob = this.response
      //     const link = document.createElement('a')
      //     link.href = window.URL.createObjectURL(blob)
      //     // link.download = url.substring(url.lastIndexOf("/") + 1, url.length);
      //     link.download = '图片.' + imgsrc.substring(imgsrc.lastIndexOf('.') + 1, imgsrc.length)
      //     // 此写法兼容可火狐浏览器
      //     document.body.appendChild(link)
      //     const evt = document.createEvent('MouseEvents')
      //     evt.initEvent('click', false, false)
      //     link.dispatchEvent(evt)
      //     window.URL.revokeObjectURL(link.href)
      //     document.body.removeChild(link)
      //     console.log(link.download)
      //     console.log(link.substring)
      //   }
      // }
      // xmlhttp.send()

      // 先测试一下能不能跨域成功
      // const myHeaders = new Headers({
      //   'Access-Control-Allow-Origin': '*',
      //   'Content-Type': 'text/plain',
      //   origin: '1'
      // })
      // fetch(imgsrc, {
      //   method: 'GET',
      //   headers: myHeaders,
      //   mode: 'cors'
      // }).then(res => {
      //   console.log(res)
      // })
    },
    openFilePreview (file) {
      const routeData = this.$router.resolve({
        name: 'FilePreview',
        query: { id: file.FileId }
      })
      window.open(routeData.href, '_blank')
    },
    fileOnClick () {
      this.files2 = []
      this.files2.push(...this.files)
    },
    fileOnChange (list) {
      if (!list && list.length !== 0) {
        this.files2.push(...list)
      }
      this.files.push(...this.files2)
      console.log(this.files)
    },
    fileOnClear () {
      this.files2 = []
      this.files = []
    },
    isMobile () {
      return utils.methods.isMobile()
    },
    onRead () {
      console.log(this.files)
    },
    expire (time) {
      return utils.methods.expire(time)
    },
    review () {
      if (this.data.SolicitReviewTime) {
        const times = this.data.SolicitReviewTime.split('--')
        if (!this.expire(times[0].replace(/-/g, '/'))) {
          this.showDialog(1)
        } else {
          if (this.expire(times[1].replace(/-/g, '/'))) {
            this.showDialog(2)
          } else {
            window.location.href = this.pingshen
          }
        }
      } else {
        this.showDialog(1)
      }
    },
    refreshUploader () {
      console.log(this.uploader.getOption().browse_button[0])
      if (this.uploader === null) {
        this.uploader.refresh()
      }
    },
    getVedioUrl () {
      console.log(this.vedioUrl)
      // const http = new XMLHttpRequest()
      // http.open('HEAD', this.vedioUrl)
      // http.onreadystatechange = function () {
      //   if (this.readyState === this.DONE) {
      //     if (this.status !== 404) {
      //       this.canPlay = true
      //     } else {
      //       this.msg = '视频转码中，请稍后进行尝试'
      //       this.snackbar = true
      //     }
      //   }
      // }
      // http.send()
      this.$http.get(this.vedioUrl).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.canPlay = true
        } else {
          this.msg = '视频转码中，请稍后进行尝试'
          this.snackbar = true
        }
      }).catch(e => {
        this.msg = '视频转码中，请稍后进行尝试'
        this.snackbar = true
        console.log(e)
      })
    },
    initVedio () {
      document.addEventListener('WeixinJSBridgeReady', function () {
        const video = document.getElementById('myVideo')
        video.load()
      })
    },
    startCountDown () {
      const vedioUrl = this.urlPrefix + this.transcodeUrl
      this.isUploaded = true
      console.log(this.isUploaded)
      this.timeInterval = setInterval(() => {
        if (this.maxtime > 0) {
          this.maxtime--
          this.uploadPlayName = '视频转码中(' + this.maxtime + ')'
          // this.getVedioUrl()
        } else {
          this.canPlay = true
          this.uploadPlayName = ''
          clearInterval(this.timeInterval)
        }
      }, 1000)
      this.videoInterval = setInterval(() => {
        if (!this.canPlay) {
          this.$http.get(vedioUrl).then(res => {
            console.log(res)
            if (res.status === 200) {
              this.canPlay = true
              this.vedioUrl = this.urlPrefix + this.transcodeUrl
              clearInterval(this.videoInterval)
            }
          }).catch(e => {
            console.log(e)
          })
        }
      }, 3000)
    },
    async getSignatureMsg (filesize) {
      await this.$http.get('/AliFile/GetSignatureMsg', {
        requestBase: 'VUE_APP_API_TWO',
        params: {
          fileLength: 1048576000,
          fileType: 2
        }
      }).then(res => {
        if (res.data.ret === 0) {
          console.log(res)
          this.urlPrefix = res.data.msg_en
          this.signature = JSON.parse(res.data.msg)
          console.log(this.signature)
        } else {
          this.msg = res.data.msg
          this.snackbar = true
        }
      }).catch(e => {
        this.msg = 'error'
        this.snackbar = true
        console.log(e)
      })
    },
    random_string (len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    get_suffix (filename) {
      var pos = filename.lastIndexOf('.')
      if (pos !== -1) {
        this.suffix = filename.substring(pos).toLowerCase()
      }
    },
    calculate_object_name (filename) {
      this.get_suffix(filename)
      var myDate = new Date()
      // this.suffix = this.suffix === '.mov' ? '.mp4' : this.suffix
      console.log(this.suffix)
      const fileName = this.signature.dir + 'EssayVideos/' + myDate.getFullYear() + '/' + (myDate.getMonth() + 1) + '/' + myDate.getDate() + '/' + this.random_string(18)
      this.g_object_name = fileName + this.suffix
      this.transcodeUrl = fileName + '.mp4'
      if (this.vedioFile) {
        var suf = this.vedioFile.name.lastIndexOf('.')
        if (suf !== -1) {
          this.transcodeFileName = this.vedioFile.name.substring(0, suf) + '.mp4'
          console.log(this.transcodeFileName)
        }
      }
    },
    async set_upload_param (up, filesize, filename, ret) {
      if (ret === false) {
        await this.getSignatureMsg(filesize)
      }
      this.g_object_name = this.signature.dir
      if (filename !== '') {
        this.get_suffix(filename)
        this.calculate_object_name(filename)
      }
      const newMultipartParams = {
        // key: this.g_object_name,
        // policy: 'eyJleHBpcmF0aW9uIjoiMjAyMS0xMi0wMlQxMjowMDowMC4wMDBaIiwiY29uZGl0aW9ucyI6W1siY29udGVudC1sZW5ndGgtcmFuZ2UiLDAsMTA0ODU3NjAwMF1dfQ==',
        // OSSAccessKeyId: 'LTAIqNJmMTIGerYa',
        // success_action_status: '200', // 让服务端返回200,不然，默认会返回204
        // signature: 'vlnbV8OcLUsLyafEAZUJ5dvmTx0='
        key: this.g_object_name,
        policy: this.signature.policy,
        OSSAccessKeyId: this.signature.accessid,
        success_action_status: '200', // 让服务端返回200,不然，默认会返回204
        signature: this.signature.signature
      }
      up.setOption({
        url: this.signature.host,
        multipart_params: newMultipartParams
      })
      console.log(this.signature.host)
      console.log(newMultipartParams)
      up.start()
    },
    uploadVedio () {
      const that = this
      this.uploader = new plupload.Uploader({
        runtimes: 'html5,html4,silverlight,flash',
        browse_button: document.getElementById('pickfiles'),
        multi_selection: false,
        // container: document.getElementById('container'),
        // flash_swf_url: '/2.0/js/plupload/Moxie.swf',
        // silverlight_xap_url: '/2.0/js/plupload/Moxie.xap',
        filters: {
          mime_types: [{ title: 'files', extensions: 'mp4,mov', extensions2: 'video/mp4' }]
        },
        url: 'https://oss.aliyuncs.com',
        init: {
          FilesAdded: function (up, files) {
            console.log('aaaaaa')
            plupload.each(files, function (file) {
              var fileName = file.name
              var extName = fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length)
              if ('*.mp4'.indexOf(extName.toLowerCase()) < 0 && '*.mov'.indexOf(extName.toLowerCase()) < 0) {
                that.msg = '该文件不允许上传,请重新选择'
                that.dialog = true
                up.removeFile(file)
                up.refresh()
              } else {
                if (file.size > '600 * 1024 * 1024') {
                  that.msg = '该文件大小超出限制,不能超过500M,请重新选择'
                  that.dialog = true
                  up.removeFile(file)
                  up.refresh()
                } else {
                  if (plupload.formatSize(file.size) === 'N/A') {
                    that.msg = '文件上传失败,请重新选择'
                    that.dialog = true
                    up.removeFile(file)
                    up.refresh()
                  } else if (that.hasFile) {
                    that.msg = '只能上传一个视频文件，需要重新上传请先删除已经上传的文件'
                    that.dialog = true
                    if (up.files.length > 1) {
                      up.removeFile(files[0])
                      up.refresh()
                    }
                  } else {
                    that.canPlay = false
                    that.maxtime = 60 * 5
                    that.isUploaded = false
                    that.hasFile = true
                    that.vedioFile = file
                    // $('#div_Video').hide()
                    // $('#HidVideoName').val(fileName)
                    // document.getElementById('videofilelist').innerHTML += '<div id="' + file.id + '">' + file.name + ' (' + plupload.formatSize(file.size) + ')<b></b><span><span></div>';
                    that.set_upload_param(up, file.size, file.name, false)
                  }
                }
              }
            })
          },
          BeforeUpload: function (up, file) {
            console.log('3333')
            // that.set_upload_param(up, file.name, true)
          },
          UploadProgress: function (up, file) {
            console.log('4444-----' + file.percent)
            // $("b", "#" + file.id).eq(0).html("<span>" + file.percent + "%</span>");
            // console.log(file.percent);
            // $('#progress-bar').css("width", 2 * file.percent + "px");
            // $('#progress-bar').attr("aria-valuenow", file.percent);
            // $('#div_progress').show();
            // $("#btn_submit").attr("disabled", "disabled");
            // $('#btn_submit').css("background", "#a6a9ab");
            that.videoProgress = file.percent
          },
          FileUploaded: function (up, file, info) {
            console.log(file)
            console.log(info)
            if (info.status === 200 || info.status === 203) {
              // $('#btn_submit').removeAttr("disabled");
              // $('#btn_submit').css("background", "#0894d5");
              // $('#HidVideoUrl').val(g_object_name);
              // $('#div_progress').hide();
              // $.ajax({
              //   url: "/Account/AddEssayVideo",
              //   type: "POST",
              //   dataType: "json",
              //   cache: false,
              //   data: $('#form').serialize(),
              //   success: function (result) {
              //       if (result.Status == 200) {
              //           $("span", "#" + file.id).eq(0).html("<img src='/Contents/Images/cancel.png' border=\"0\" alt=\"删除该附件\" title=\"删除该附件\"  />");
              //           $("#FileCount").val(1);
              //           $('#tr_alert').show();
              //           $('#span_alert').text("视频转码中");
              //           $('#btn_reload').show();
              //           $('#btn_submit').val("已提交完成，结束");
              //           $.jMessageBox.show('系统消息', "恭喜您，视频上传成功！<br/>5分钟以后可尝试预览视频。");
              //           SetReloadButton($('#btn_reload'));
              //           return false;
              //       } else {
              //           $.jMessageBox.show('系统消息', result.Message);
              //           return false;
              //       }
              //   },
              //   error: function () {
              //       $.jMessageBox.show('系统消息', "发生网络错误，请重试");
              //       return false;
              //   }
              // })
              // that.msg = '恭喜您，视频上传成功！5分钟以后可尝试预览视频。'
              // that.dialog = true
              // that.initVedio()
              // that.vedioUrl = that.urlPrefix + that.g_object_name
              that.startCountDown()
            } else {
              that.msg = '上传失败,请重试'
              that.dialog = true
            }
          },
          FilesRemoved: function (up, files) {
            // that.uploader.setOption('browse_button', 'pickfiles')
            that.canPlay = false
            clearInterval(that.timeInterval)
            clearInterval(that.videoInterval)
            that.vedioUrl = ''
            that.maxtime = 60 * 5
            that.isUploaded = false
            that.hasFile = false
            that.vedioFile = null
            that.videoProgress = 0
          },
          Error: function (up, err) {
            console.log(err.response)
            that.hasFile = false
            if (err.code === -600) {
              that.msg = '视频上传失败，选择的文件太大了'
            } else if (err.code === -601) {
              that.msg = '视频上传失败，选择的文件后缀不对'
            } else if (err.code === -602) {
              that.msg = '视频上传失败，这个文件已经上传过一遍了'
            } else {
              that.msg = '视频上传失败，请刷新页面重新上传或更换浏览器再次尝试'
            }
            that.dialog = true
          }
        }
      })
      this.uploader.init()
    }
  }
}
</script>
